//import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './library/foundation';

import * as Utilities from './components/Utilities';
import { ScrollTriggerHome, CreateBatch } from './components/ScrollTrigger';
import Offcanvas from './components/Offcanvas';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebookF,
  faLinkedinIn,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';

library.add(faFacebookF, faLinkedinIn, faInstagram, faChevronRight);

dom.watch();

$(document).foundation();

document.addEventListener('DOMContentLoaded', function () {
  if (document.body.classList.contains('home')) {
    let mql = window.matchMedia('print, screen and (min-width: 40em)');

    Utilities.midnightScreenTest(mql);
    mql.addEventListener('change', Utilities.midnightScreenTest);

    ScrollTriggerHome();
  }

  Utilities.getCircleSize();
  window.addEventListener('resize', Utilities.getCircleSize());

  Offcanvas();

  if (
    document.body.classList.contains('page-nos-projets') ||
    document.body.classList.contains('page-les-actus')
  ) {
    ScrollTrigger.config({
      limitCallbacks: true,
    });

    gsap.to('main', {
      delay: 0.25,
      duration: 0.3,
      autoAlpha: 1,
      ease: 'power2.out',
      onComplete: () => {
        CreateBatch('.acf-block-figure');
        gsap.to('.load-more-button', { autoAlpha: 1 });
      },
    });
  }
});
